<template>
  <div class="order-status">
    <div class="success" v-if="status === 1">
      <i class="anyteachicon anyteach-check-circle" />
      <span>支付成功</span>
    </div>
    <div class="error" v-if="status === 0 || status === 2">
      <i class="anyteachicon anyteach-error" />
      <span>未支付</span>
    </div>
    <div v-if="status === 3">
      <i class="anyteachicon anyteach-refund" />
      <span>已退款</span>
    </div>
    <div v-if="status === 4">
      <i class="anyteachicon anyteach-refund" />
      <span>已部分退款</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["status"]
}
</script>

<style lang="scss" scoped>
.order-status {
  text-align: center;
  font-size: 0.9rem;

  i {
    font-size: inherit;
    margin-right: 3px;
  }

  span {
    @include avenir-demi();
  }
  .success {
    color: $red;
  }
  .error {
    color: $red;
  }
}
</style>